import React from 'react';

export default function AgGridThemeNav({
  anchor,
}) {
  const download = '/getting-started';
  const view = '/themes';
  return (
    <div>
      <div className="grid dark-theme-nav">
        <div className="grid__col-4">
          <a className="btn" href={`${ download }`}>Download Theme</a>
        </div>
        <div className="grid__col-4">
          <a className="btn" href={`${ view }#${ anchor }`}>View Theme</a>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./styleguide/components/common/ag-grid-theme-nav.js